import { useState, useEffect, SetStateAction, Dispatch } from 'react';
import { Collapsible } from 'containers/LawyerDocumentsPage/typings';

const useCollapse = (
  items: any[],
): [Collapsible, Dispatch<SetStateAction<Collapsible>>] => {
  const initialState = items.map((r: any, i: number) => ({
    [i]: false,
  }));

  const [expandRow, setExpandRow] = useState<Collapsible>(undefined);

  useEffect(() => {
    setExpandRow(Object.assign({}, ...initialState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [expandRow, setExpandRow];
};

export default useCollapse;
